import React, {useState, useRef} from "react";
import {Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, IconButton, Typography} from "@mui/material";
import CloseIcon from "../../../assets/icons/close.png";
import {ThreeDots} from "react-loader-spinner";

const AnomalyLogActionDialog = (props) => {

    const {openLogAction, setOpenLogAction, breakpoints, anomalyId, anomalyDetectionDetails, isCreatingAnomalyDetectionRemarks, 
        isInvalidatingAnomalyDetectionRemarks, createAnomalyDetectionRemarks, invalidateAnomalyDetectionRemarks
    } = props;


    const [remarks, setRemarks] = useState(anomalyDetectionDetails?.remarks);
    const prevRemarksRef = useRef(remarks);

    const characterLimit = 200;

    const handleCloseDialog = () => {
        setOpenLogAction(false);
    }

    const handleRemarksTextfieldChange = (e) => {
        const value = e.target.value;

        if (value.length <= characterLimit) {
            setRemarks(value);
        }
    }

    const handleSaveRemarks = (e) => {
        const prevRemarks = prevRemarksRef.current;

        if (prevRemarks !== remarks) {
            createAnomalyDetectionRemarks(anomalyId, remarks);

        } else {
            setOpenLogAction(false);
        }
    }

    const handleInvalidateRemarks = (e) => {
        invalidateAnomalyDetectionRemarks(anomalyId, remarks);
    }


    return (
        <Dialog open={openLogAction} onClose={handleCloseDialog} maxWidth="sm" fullWidth PaperProps={{style: {borderRadius: "8px", padding: " 20px 24px"}, elevation: 24}}>
            <DialogTitle sx={{display: "flex"}}>
                <Typography variant="h5" sx={{color: "#58565f", fontSize: 20, fontWeight: "bold"}}>
                    Anomaly Action
                </Typography>
                
                <IconButton
                    aria-label="close"
                    onClick={handleCloseDialog}
                    sx={{position: 'absolute', right: 36, top: 24}}
                >
                    <img alt="close-icon" src={CloseIcon} style={{height: 22}} />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{mt: 3}}>
                <Typography variant="body1" sx={{fontSize: 16, color: "#58565f"}}>
                    <strong style={{color: "#58565f"}}>Hash Reference:</strong> {anomalyDetectionDetails?.ovi}
                </Typography>

                <TextField
                    variant="outlined"
                    fullWidth
                    defaultValue={anomalyDetectionDetails?.fraud_type}
                    InputProps={{
                        readOnly: true,
                    }}
                    sx={{fontSize: 16, color: "#58565f", mt: 1,
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: "#7A78F7C9", 
                            },
                            '&:hover fieldset': {
                                borderColor: "#7A78F7C9", 
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: "#7A78F7C9",
                            },
                        },
                    }}
                    inputProps={{maxLength: characterLimit}}
                />

                <TextField
                    variant="outlined"
                    fullWidth
                    multiline
                    rows={4}
                    value={remarks}
                    onChange={(e) => handleRemarksTextfieldChange(e)}
                    sx={{fontSize: 16, color: "#58565f", mt: "15px",
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: "#7A78F7C9", 
                            },
                            '&:hover fieldset': {
                                borderColor: "#7A78F7C9", 
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: "#7A78F7C9",
                            },
                        },
                    }}
                />

                <Typography align="right" sx={{color: (remarks?.length === characterLimit) ? "red" : "#58565f", fontSize: 12, mt: "5px"}}>
                    {remarks?.length}/{characterLimit}
                </Typography>
            </DialogContent>

            <DialogActions sx={{padding: "12px 24px 20px 24px"}}>
                <Button variant="contained" sx={{width: (breakpoints == "xs" || breakpoints == "sm") ? {} : "28%", backgroundColor: "#E76C59", textTransform: "none", "&:hover": {backgroundColor: "#E76C59"}}}
                    startIcon={isInvalidatingAnomalyDetectionRemarks && <ThreeDots height="20" width="20" radius="9" color="#ffff" ariaLabel="three-dots-loading" visible={true} />}
                    onClick={(e) => handleInvalidateRemarks(e)}
                >
                    {(isInvalidatingAnomalyDetectionRemarks) ? "Invalidating" : "Invalidate"}
                </Button>

                &nbsp; &nbsp;

                <Button variant="contained" sx={{backgroundColor: "#5959D8", textTransform: "none", width: (breakpoints == "xs" || breakpoints == "sm") ? {} : "28%", "&:hover": {backgroundColor: "#5959D8"}}}
                    startIcon={isCreatingAnomalyDetectionRemarks && <ThreeDots height="20" width="20" radius="9" color="#ffff" ariaLabel="three-dots-loading" visible={true} />}
                    onClick={(e) => handleSaveRemarks(e)}
                >
                    {(isCreatingAnomalyDetectionRemarks) ? "Saving" : "Save Remarks"}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default AnomalyLogActionDialog

